module.exports = __webpack_public_path__ + "34875eb70825f804d9b6f3718948b67a.png";